import { render, staticRenderFns } from "./quizList.vue?vue&type=template&id=9f226336&"
import script from "./quizList.vue?vue&type=script&lang=js&"
export * from "./quizList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports